import { AxiosInstance } from "axios";
import { logger } from "../../../utils/logger";

/**
 * Interceptor de logging para monitoramento de requisições
 * 
 * Funcionalidades:
 * - Log de requisições e respostas
 * - Métricas de performance
 * - Debug de desenvolvimento
 * - Monitoramento de API
 */
export const setupLoggingInterceptor = (client: AxiosInstance): void => {
  client.interceptors.request.use(
    (config) => {
      // Log da requisição
      logger.debug("[Logging Interceptor] Request:", {
        method: config.method?.toUpperCase(),
        url: config.url,
        headers: config.headers,
        data: config.data,
      });
      return config;
    },
    (error) => {
      logger.error("[Logging Interceptor] Request error:", error);
      return Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    (response) => {
      // Log da resposta removido para reduzir spam no console
      return response;
    },
    (error) => {
      // Log de erro já tratado pelo error interceptor
      return Promise.reject(error);
    }
  );
}; 